<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Tracking Details
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/">
                        Vehicle Tracking Details</router-link
                      >
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
              <div class="card-header px-0 common_top_title_searchbgst_dock">
                <div class="container-fluid">
                  <div class="row row fc_my-05">
                    <div class="w-auto px-1 mobile-padding-0-2">
                      <div
                        class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                      >
                        <div class="avatar-content">
                          <i
                            class="i_icon_st la-people-carry las lab font-medium-5"
                          ></i>
                        </div>
                      </div>
                      <h4 class="card-title d-inline-flex ml-0 mb-0">
                        Vehicle Tracking
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 px-0">
                <div class="card text-center mb-1 p-2 d-none">
                  <div class="container px-0">
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Total Running Vehilcle</th>
                            <th>On Time Vehicles</th>
                            <th>GPS Vehicles</th>
                            <th>Non GPS Vehicles</th>
                            <th>Dealyed on Gate</th>
                            <th>Dealyed on Dock</th>
                            <th>Delayed Intrasit</th>
                            <th>Idle Vehicles Number</th>
                            <th>Accident Vehicle Numbers</th>
                            <th>Stop Vehicles Number</th>
                            <th>InactiveVehicles Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          <vue-element-loading
                            :active="isSummaryLoading"
                            color="#FF6700"
                          />
                          <tr>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'total_running_vehicles'
                                )
                              "
                            >
                              {{
                                summary.total_running_vehicles
                                  ? summary.total_running_vehicles
                                  : 0
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'on_time_vehicles')
                              "
                            >
                              {{ roundNumber(summary.on_time_vehicles) }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'gps_vehicles')
                              "
                            >
                              {{
                                summary.gps_vehicles
                                  ? summary.gps_vehicles
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'not_gps_vehicles')
                              "
                            >
                              {{
                                summary.not_gps_vehicles
                                  ? summary.not_gps_vehicles
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'delayed_on_gate')
                              "
                            >
                              {{
                                summary.delayed_on_gate
                                  ? summary.delayed_on_gate
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'delayed_on_dock')
                              "
                            >
                              {{
                                summary.delayed_on_dock
                                  ? summary.delayed_on_dock
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'delayed_intransit')
                              "
                            >
                              {{
                                summary.delayed_intransit
                                  ? summary.delayed_intransit
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'idle_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.idle_vehicle_numbers
                                  ? summary.idle_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'accident_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.accident_vehicle_numbers
                                  ? summary.accident_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'stop_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.stop_vehicle_numbers
                                  ? summary.stop_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'inactive_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.inactive_vehicle_numbers
                                  ? summary.inactive_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="table-responsive datatableview">
                    <table
                      id="haul_form"
                      class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                    >
                      <thead>
                        <tr>
                          <th class="text-left align-middle">Sr No.</th>
                          <th class="text-left align-middle">Flag</th>
                          <th class="text-left align-middle">Action</th>
                          <th class="text-left align-middle">
                            Vehicle Live Status
                          </th>
                          <th class="text-left align-middle">On Time</th>
                          <th class="text-left align-middle">Map</th>
                          <th
                            class="text-left align-middle"
                            style="min-width: 220px"
                          >
                            Trip Details
                          </th>
                          <th
                            class="text-left align-middle"
                            style="min-width: 220px"
                          >
                            Route Details
                          </th>
                          <th
                            class="text-left align-middle"
                            style="min-width: 220px"
                          >
                            From & To Location Details
                          </th>
                          <th
                            class="text-left align-middle"
                            style="min-width: 220px"
                          >
                            Vehicle Details
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <vue-element-loading
                          :active="isMasterListLoading"
                          color="#FF6700"
                        />
                        <template v-for="(data, index) of haul_form.list">
                          <tr>
                            <td data-column="Trip ID" class="text-left">
                              {{
                                index +
                                1 +
                                haul_form.currPageNum * haul_form.pagelimit
                              }}
                            </td>
                            <td data-column="Flag" class="text-left">Red</td>
                            <td data-column="Action" class="text-left">Call</td>
                            <td data-column="Status" class="text-left">
                              Vehicle Live Status
                            </td>
                            <td data-column="On Time" class="text-left">
                              On Time
                            </td>
                            <td data-column="Map" class="text-left">-</td>
                            <td
                              data-column="Trip Details"
                              class="text-left merge_column_detals"
                            >
                              <div class="meger_details">
                                <span class="title_name_text"> TRIP ID :</span>
                                <span class="title_value_text">
                                  {{ data.trip_id }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text">
                                  Trip Date :</span
                                >
                                <span class="title_value_text">
                                  {{ data.trip_date }}</span
                                >
                              </div>
                              <hr />
                            </td>
                            <td
                              data-column="Route Details"
                              class="text-left merge_column_detals"
                            >
                              <div class="meger_details">
                                <span class="title_name_text">
                                  Route No. :</span
                                >
                                <span class="title_value_text">
                                  {{ data.route_no }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text">
                                  Route Distance :</span
                                >
                                <span class="title_value_text">
                                  {{ data.route_distance_km }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text">
                                  Route Path :</span
                                >
                                <span class="title_value_text">
                                  {{ data.route_path }}</span
                                >
                              </div>
                              <hr />
                            </td>
                            <td
                              data-column="From & To Location Details"
                              class="text-left merge_column_detals"
                            >
                              <div class="meger_details">
                                <span class="title_name_text"> From OU :</span>
                                <span class="title_value_text">
                                  {{ data.from_ou }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text">
                                  From Zone :</span
                                >
                                <span class="title_value_text">
                                  {{ data.from_zone }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text"> From EDC :</span>
                                <span class="title_value_text">
                                  {{ data.from_edc }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text"> To OU :</span>
                                <span class="title_value_text">
                                  {{ data.to_ou }}</span
                                >
                              </div>
                              <div class="meger_details">
                                <span class="title_name_text"> To Zone :</span>
                                <span class="title_value_text">
                                  {{ data.to_zone }}</span
                                >
                              </div>
                              <div class="meger_details">
                                <span class="title_name_text"> To EDC :</span>
                                <span class="title_value_text">
                                  {{ data.to_edc }}</span
                                >
                              </div>
                              <hr />
                            </td>
                            <td
                              data-column="Vehicle Details"
                              class="text-left merge_column_detals"
                            >
                              <div class="meger_details">
                                <span class="title_name_text"> Reg No. :</span>
                                <span class="title_value_text">
                                  {{ data.vehicle_registration_no }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text"> Type :</span>
                                <span class="title_value_text">
                                  {{ data.vehicle_type }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text"> OTA :</span>
                                <span class="title_value_text">
                                  {{ data.ota }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text">
                                  Route Catg :</span
                                >
                                <span class="title_value_text">
                                  {{ data.vehicle_route_type }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text"> Name :</span>
                                <span class="title_value_text">
                                  {{ data.driver_name }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text"> Mobile :</span>
                                <span class="title_value_text">
                                  {{ data.driver_mobile }}</span
                                >
                              </div>
                              <hr />
                              <div class="meger_details">
                                <span class="title_name_text">
                                  Vehicle Attached EDC/OU :</span
                                >
                                <span class="title_value_text"> -</span>
                              </div>
                              <hr />
                            </td>
                            >
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <div
                    class="pageCenter text-center mt-4 pagination_viewallpages"
                  >
                    <pagination
                      v-model="haul_form.page"
                      :records="haul_form.totalcount"
                      :per-page="haul_form.pagelimit"
                      @paginate="(e) => handlePageChange(e, 'haul_form')"
                    />
                  </div>
                </div>
              </div>
              <div class="container py-2">
                <div class="container px-0">
                  <!-- <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Total Running Vehilcle</th>
                            <th>On Time Vehicles</th>
                            <th>GPS Vehicles</th>
                            <th>Non GPS Vehicles</th>
                            <th>Dealyed on Gate</th>
                            <th>Dealyed on Dock</th>
                            <th>Delayed Intrasit</th>
                            <th>Idle Vehicles Number</th>
                            <th>Accident Vehicle Numbers</th>
                            <th>Stop Vehicles Number</th>
                            <th>InactiveVehicles Number</th>
                          </tr>
                        </thead>
                        <tbody>
                          <vue-element-loading
                            :active="isSummaryLoading"
                            color="#FF6700"
                          />
                          <tr>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'total_running_vehicles'
                                )
                              "
                            >
                              {{
                                summary.total_running_vehicles
                                  ? summary.total_running_vehicles
                                  : 0
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'on_time_vehicles')
                              "
                            >
                              {{ roundNumber(summary.on_time_vehicles) }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'gps_vehicles')
                              "
                            >
                              {{
                                summary.gps_vehicles
                                  ? summary.gps_vehicles
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'not_gps_vehicles')
                              "
                            >
                              {{
                                summary.not_gps_vehicles
                                  ? summary.not_gps_vehicles
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'delayed_on_gate')
                              "
                            >
                              {{
                                summary.delayed_on_gate
                                  ? summary.delayed_on_gate
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'delayed_on_dock')
                              "
                            >
                              {{
                                summary.delayed_on_dock
                                  ? summary.delayed_on_dock
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList('haul_form', 'delayed_intransit')
                              "
                            >
                              {{
                                summary.delayed_intransit
                                  ? summary.delayed_intransit
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'idle_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.idle_vehicle_numbers
                                  ? summary.idle_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'accident_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.accident_vehicle_numbers
                                  ? summary.accident_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'stop_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.stop_vehicle_numbers
                                  ? summary.stop_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                            <td
                              class="cell_active"
                              @click="
                                getMasterList(
                                  'haul_form',
                                  'inactive_vehicle_numbers'
                                )
                              "
                            >
                              {{
                                summary.inactive_vehicle_numbers
                                  ? summary.inactive_vehicle_numbers
                                  : "0"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> -->
                </div>
                <div class="row match-height gateperformanceiconTrakingdb">
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-01 mb-1 cls-pointer"
                      @click="
                        getMasterList('haul_form', 'total_running_vehicles')
                      "
                    >
                      <div
                        class="gateperformanceicon gateperformanceicontrackingicon"
                      >
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.total_running_vehicles
                                ? summary.total_running_vehicles
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">
                          Total Running Vehicles
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-02 mb-1 cls-pointer"
                      @click="getMasterList('haul_form', 'on_time_vehicles')"
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.on_time_vehicles
                                ? summary.on_time_vehicles
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">On Time Calls</h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-03 mb-1 cls-pointer"
                      @click="getMasterList('haul_form', 'delayed_on_gate')"
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.delayed_on_gate
                                ? summary.delayed_on_gate
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">Delayed on Gate</h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-04 mb-1 cls-pointer"
                      @click="getMasterList('haul_form', 'delayed_on_dock')"
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.delayed_on_dock
                                ? summary.delayed_on_dock
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">Delayed on Dock</h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-05 mb-1 cls-pointer"
                      @click="getMasterList('haul_form', 'delayed_intransit')"
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.delayed_intransit
                                ? summary.delayed_intransit
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">Delayed in transit</h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-06 mb-1 cls-pointer"
                      @click="
                        getMasterList('haul_form', 'idle_vehicle_numbers')
                      "
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.idle_vehicle_numbers
                                ? summary.idle_vehicle_numbers
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">Idle Vehicles</h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-06 mb-1 cls-pointer"
                      @click="
                        getMasterList('haul_form', 'accident_vehicle_numbers')
                      "
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.accident_vehicle_numbers
                                ? summary.accident_vehicle_numbers
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">Accident Vehicles</h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-05 mb-1 cls-pointer"
                      @click="
                        getMasterList('haul_form', 'stop_vehicle_numbers')
                      "
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.stop_vehicle_numbers
                                ? summary.stop_vehicle_numbers
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">Breakdown Vehicles</h2>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-6 col-sm-6 col-md-3 col-xl-2 gateperformanceicon_col_px5"
                  >
                    <div
                      class="card text-center my_projects-bgs_co performance_projects-bgs-04 mb-1 cls-pointer"
                      @click="
                        getMasterList('haul_form', 'inactive_vehicle_numbers')
                      "
                    >
                      <div class="gateperformanceicon">
                        <div class="avatar bg-light-warning p-50 mb-1">
                          <div class="avatar-content avatar_iconsview">
                            <img
                              alt=""
                              class="round"
                              src="../../../public/images/icons/truck-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="card-body card_crossdock_image pt-0 pb-1 px-0"
                      >
                        <div class="timeGatetimeview">
                          <span class="avgGatetimeview">
                            {{
                              summary.inactive_vehicle_numbers
                                ? summary.inactive_vehicle_numbers
                                : 0
                            }}</span
                          >
                        </div>
                        <h2 class="font-weight-bolder">Inactive Vehicles</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive trip_tracking_details">
                  <table class="table border">
                    <thead>
                      <tr>
                        <th class="text-left py-2">Trip / Route Details</th>
                        <th class="text-left py-2">
                          From & To Location Details
                        </th>
                        <th class="text-left py-2">Vehicles Details</th>
                        <th class="text-left py-2">TIme Details</th>
                        <th class="text-left align-middle">Expand</th>
                      </tr>
                    </thead>
                    <tbody>
                      <vue-element-loading
                        :active="isMasterListLoading"
                        color="#FF6700"
                      />
                      <template v-for="(data, index) of haul_form.list">
                        <tr>
                          <td
                            data-column=""
                            class="text-left align-top merge_column_detals"
                          >
                            <div
                              class="d-flex justify-content-between justify-content-center align-items-center trackinglisticon trackinglisticonbg rackinglisticonbg-01"
                            >
                              <div class="title_name_text">Call To Driver</div>
                              <div class="trackinglist_all_icon">
                                <img
                                  @click="callBot(data)"
                                  style="cursor: pointer"
                                  alt=""
                                  class="round img-fluid"
                                  src="../../../public/images/icons/call.png"
                                />
                              </div>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Driver Name :
                              </span>
                              <span class="title_value_text">
                                {{ data.driver_name }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Driver Mobile Number :
                              </span>
                              <span class="title_value_text">
                                {{ data.driver_mobile }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> TRIP ID :</span>
                              <span class="title_value_text">
                                {{ data.trip_id }}</span
                              >
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> Trip Date: </span>
                              <span class="title_value_text">
                                {{ data.trip_date }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> Route No : </span>
                              <span class="title_value_text">
                                {{ data.route_no }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Route Distance:
                              </span>
                              <span class="title_value_text">
                                {{ data.route_distance_km }} KM
                              </span>
                            </div>
                          </td>
                          <td
                            data-column=""
                            class="text-left align-top merge_column_detals"
                          >
                            <div
                              class="d-flex justify-content-between justify-content-center align-items-center trackinglisticon trackinglisticonbg rackinglisticonbg-02"
                            >
                              <div class="title_name_text">
                                Vehicle Live Status
                              </div>
                              <div class="trackinglist_all_icon">
                                <img
                                  alt=""
                                  class="round img-fluid"
                                  src="../../../public/images/icons/vehicle-tracking.png"
                                />
                              </div>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> From Ou :</span>
                              <span class="title_value_text">
                                {{ data.from_ou }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> From zone: </span>
                              <span class="title_value_text">
                                {{ data.from_zone }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> From EDC: </span>
                              <span class="title_value_text">
                                {{ data.from_edc }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> To Ou : </span>
                              <span class="title_value_text">
                                {{ data.to_ou }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> To Zone : </span>
                              <span class="title_value_text">
                                {{ data.to_zone }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> To EDC : </span>
                              <span class="title_value_text">
                                {{ data.to_edc }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Route Path :
                              </span>
                              <span class="title_value_text">
                                {{ data.route_path }}
                              </span>
                            </div>
                          </td>
                          <td
                            data-column=""
                            class="text-left align-top merge_column_detals"
                          >
                            <div
                              class="d-flex justify-content-between justify-content-center align-items-center trackinglisticon trackinglisticonbg rackinglisticonbg-03"
                            >
                              <div class="title_name_text">On Time</div>
                              <div class="trackinglist_all_icon">
                                <img
                                  alt=""
                                  class="round img-fluid"
                                  src="../../../public/images/icons/onTime.png"
                                />
                              </div>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> Veh Reg No:</span>
                              <span class="title_value_text">
                                {{ data.vehicle_registration_no }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Vehicle Type :
                              </span>
                              <span class="title_value_text">
                                {{ data.vehicle_type }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text"> OTA : </span>
                              <span class="title_value_text">
                                {{ data.ota }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Vehicle Route Catg :
                              </span>
                              <span class="title_value_text">
                                {{ data.vehicle_route_type }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Vehicle Attached EDC/OU :
                              </span>
                              <span class="title_value_text"> - </span>
                            </div>
                          </td>

                          <td
                            data-column=""
                            class="text-left align-top merge_column_detals"
                          >
                            <div
                              class="d-flex justify-content-between justify-content-center align-items-center trackinglisticon trackinglisticonbg rackinglisticonbg-04"
                            >
                              <div class="title_name_text">Map</div>
                              <div class="trackinglist_all_icon">
                                <img
                                  alt=""
                                  class="round img-fluid"
                                  src="../../../public/images/icons/map-t.png"
                                />
                              </div>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Departure Date :</span
                              >
                              <span class="title_value_text">
                                {{
                                  data.DEPARTUREDATE ? data.DEPARTUREDATE : "-"
                                }}
                              </span>
                            </div>
                            <div class="meger_details">
                              <span class="title_name_text">
                                Arrival Date :
                              </span>
                              <span class="title_value_text">
                                {{ data.arrival_date }}
                              </span>
                            </div>
                          </td>
                          <td class="text-left align-middle py-1">
                            <span class="tracking_downarrows">
                              <svg
                                v-if="opened && data.id === opened"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="hero-icon"
                                @click="
                                  expandRow(
                                    data.id,
                                    data.route_path,
                                    data.VehicalRegistratioNo
                                  )
                                "
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="m4.5 15.75 7.5-7.5 7.5 7.5"
                                />
                              </svg>
                              <svg
                                v-else
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="hero-icon"
                                @click="
                                  expandRow(
                                    data.id,
                                    data.route_path,
                                    data.VehicalRegistratioNo
                                  )
                                "
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                                />
                              </svg>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <div class="barWrapper">
                              <span class="progressText progressTextImage">
                                <img
                                  alt=""
                                  class="round img-fluid"
                                  src="../../../public/images/icons/delivery-truck 2.png"
                                />
                              </span>
                              <div
                                class="d-flex justify-content-between justify-content-center align-items-center"
                              >
                                <div class="bombimage">
                                  <img
                                    alt=""
                                    class="round img-fluid"
                                    src="../../../public/images/icons/Subtract.png"
                                  />
                                </div>
                                <div class="bombimage">
                                  <img
                                    alt=""
                                    class="round img-fluid"
                                    src="../../../public/images/icons/Subtract.png"
                                  />
                                </div>
                              </div>
                              <div class="progress">
                                <div
                                  class="progress-bar"
                                  role="progressbar"
                                  :style="{ width: html5Progress + '%' }"
                                >
                                  <span
                                    class="popOver"
                                    v-tooltip="
                                      'HTML5 Progress: ' + html5Progress + '%'
                                    "
                                  ></span>
                                </div>
                              </div>
                              <div
                                class="d-flex justify-content-between justify-content-center align-items-center"
                              >
                                <template
                                  v-for="(route, i) in data.route_path.split(
                                    '-'
                                  )"
                                >
                                  <div class="bombitext">{{ route }}</div>
                                </template>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr
                          v-if="opened === data.trip_id"
                          :class="{ opened: opened === data.trip_id }"
                        >
                          <!-- <td class="vehicle_traking_viewlist" colspan="3"></td> -->
                          <td class="vehicle_traking_viewlist" colspan="8">
                            <div
                              :id="'mapContainer_' + data.id"
                              class="map-container"
                            ></div>
                          </td>
                          <td class="vehicle_traking_viewlist" colspan="4">
                            <div class="table-responsive">
                              <table class="table table-bordered bordered">
                                <tr>
                                  <th>Route Path</th>
                                  <td>{{ data.route_path }}</td>
                                </tr>
                                <tr>
                                  <th>Current Spent Time</th>
                                  <td>2 hours 5 minutes</td>
                                </tr>
                                <tr>
                                  <th>Trip Started At</th>
                                  <td>04 April 2025 10:02 AM</td>
                                </tr>
                                <tr>
                                  <th>Trip start location</th>
                                  <td>ABP</td>
                                </tr>
                                <tr>
                                  <th>Next touch point</th>
                                  <td>RPR</td>
                                </tr>
                                <tr>
                                  <th>Next touch point expected At</th>
                                  <td>04 April 2025 12:15 PM</td>
                                </tr>
                                <tr>
                                  <th>Is On Time</th>
                                  <td>No</td>
                                </tr>
                                <tr>
                                  <th>Trip end location</th>
                                  <td>NAGO</td>
                                </tr>
                                <tr>
                                  <th>Expected At</th>
                                  <td>04 April 2025 02:00 PM</td>
                                </tr>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <template v-if="!haul_form.list.length">
                        <tr>
                          <td colspan="6" style="text-align: center">
                            No records found
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div
                  class="pageCenter text-center mt-4 pagination_viewallpages"
                >
                  <pagination
                    v-model="haul_form.page"
                    :records="haul_form.totalcount"
                    :per-page="haul_form.pagelimit"
                    @paginate="(e) => handlePageChange(e, 'haul_form')"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import { read, utils } from "xlsx";
import schema from "../../utils/schema";
import common_methods from "../../utils/common_methods";
import searchMasterNameList from "../../utils/searchMasterNameList";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

export default {
  name: "listingDetails",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    Pagination,
  },
  data() {
    return {
      opened: null,
      un: "",
      html5Progress: 85,
      isLoading: false,
      isShipmentsSyncing: false,
      isMasterListLoading: false,
      isSummaryLoading: false,
      pagefeatures: [],
      isFormEdit: false,
      haul_details: false,
      isGpsDataLoading: false,
      summary: {
        total_running_vehicles: 0,
        on_time_vehicles: 0,
        gps_vehicles: 0,
        not_gps_vehicles: 0,
        delayed_on_gate: 0,
        delayed_on_dock: 0,
        delayed_intransit: 0,
        idle_vehicle_numbers: 0,
        accident_vehicle_numbers: 0,
        stop_vehicle_numbers: 0,
        inactive_vehicle_numbers: 0,
      },
      haul_form: {
        url: "/ct/hauls",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
        presignedUrls: [],
      },
      photoCaptureSound: "sound/iphone-camera-capture-6448.wav",
      map: null,
      directionsService: null,
      directionsRenderer: null,
      locations: [
        {
          sector_name: "DELH",
          lat: 28.4829357,
          lng: 76.81108454,
          vehicle_number_plate: "MH14HG8468",
        },
        {
          sector_name: "AMCO",
          lat: 30.20227746,
          lng: 76.87500926,
          vehicle_number_plate: "MH12LT3985",
        },
        {
          sector_name: "JSPO",
          lat: 22.83677573,
          lng: 86.23336711,
          vehicle_number_plate: "MH12LT3986",
        },
        {
          sector_name: "BOMD",
          lat: 19.32838749,
          lng: 73.1034658,
          vehicle_number_plate: "MH20BT3356",
        },
        {
          sector_name: "BWD",
          lat: 19.32861431,
          lng: 73.10352915,
          vehicle_number_plate: "MH14HG3655",
        },
        {
          sector_name: "BGM",
          lat: 15.89201189,
          lng: 74.5409106,
          vehicle_number_plate: "MH14GD1404",
        },
        {
          sector_name: "HBL",
          lat: 15.32081099,
          lng: 75.10942451,
          vehicle_number_plate: "MH43Y2893",
        },
        {
          sector_name: "VPI",
          lat: 20.3252149,
          lng: 72.90557776,
          vehicle_number_plate: "MH14KA5337",
        },
        {
          sector_name: "BDQN",
          lat: 22.398839,
          lng: 73.137974,
          vehicle_number_plate: "MH14HG3869",
        },
        {
          sector_name: "AMDI",
          lat: 22.92808983,
          lng: 72.44836951,
          vehicle_number_plate: "HR55W4756",
        },
        {
          sector_name: "AMDO",
          lat: 22.92808983,
          lng: 72.44836951,
          vehicle_number_plate: "HR55W4756",
        },
        {
          sector_name: "CCUO",
          lat: 22.76154221,
          lng: 88.31523491,
          vehicle_number_plate: "MH14KQ6037",
        },
        {
          sector_name: "PATO",
          lat: 25.5737419,
          lng: 85.23991262,
          vehicle_number_plate: "WB11F1584",
        },
        {
          sector_name: "NAGO",
          lat: 21.13866742,
          lng: 78.90309435,
          vehicle_number_plate: "OD11M0087",
        },
        {
          sector_name: "RPR",
          lat: 21.27997639,
          lng: 81.60997476,
          vehicle_number_plate: "NL01AG2486",
        },
        {
          sector_name: "HYDO",
          lat: 17.528655,
          lng: 78.441097,
          vehicle_number_plate: "WB11F1573",
        },
        {
          sector_name: "BLRO",
          lat: 12.75143254,
          lng: 77.73542494,
          vehicle_number_plate: "OD11L2687",
        },
        {
          sector_name: "SLMO",
          lat: 11.62699,
          lng: 78.13533,
          vehicle_number_plate: "RJ23GC5938",
        },
        {
          sector_name: "MAAO",
          lat: 13.04071433,
          lng: 80.02772123,
          vehicle_number_plate: "HR55AL5776",
        },
        {
          sector_name: "PNQC",
          lat: 18.44644856,
          lng: 73.89023463,
          vehicle_number_plate: "HR55AL5931",
        },
        {
          sector_name: "PNQO",
          lat: 18.44644856,
          lng: 73.89023463,
          vehicle_number_plate: "HR55AL5931",
        },
        {
          sector_name: "SVN",
          lat: 18.47426355,
          lng: 73.80930238,
          vehicle_number_plate: "HR55AL5976",
        },
        {
          sector_name: "PNQE",
          lat: 18.57847942,
          lng: 73.98578634,
          vehicle_number_plate: "HR55AM9958",
        },
        {
          sector_name: "GOI",
          lat: 15.36213232,
          lng: 73.94698977,
          vehicle_number_plate: "HR38AD0554",
        },
        {
          sector_name: "ANR",
          lat: 19.14585673,
          lng: 74.70906402,
          vehicle_number_plate: "HR38AD5454",
        },
        {
          sector_name: "RNJ",
          lat: 18.7730284,
          lng: 74.2740854,
          vehicle_number_plate: "HR55AM4642",
        },
        {
          sector_name: "NSK",
          lat: 19.9854691,
          lng: 73.72609285,
          vehicle_number_plate: "HR38AD5497",
        },
        {
          sector_name: "SNN",
          lat: 19.856815,
          lng: 73.979488,
          vehicle_number_plate: "HR55AL4079",
        },
        {
          sector_name: "OZR",
          lat: 20.07177963,
          lng: 73.89373856,
          vehicle_number_plate: "MH14KQ7944",
        },
        {
          sector_name: "DUL",
          lat: 20.83815244,
          lng: 74.7571217,
          vehicle_number_plate: "MH11CJ3299",
        },
        {
          sector_name: "IXUW",
          lat: 19.80110314,
          lng: 75.23071114,
          vehicle_number_plate: "MH11CH3299",
        },
        {
          sector_name: "IXUE",
          lat: 19.87778337,
          lng: 75.37998454,
          vehicle_number_plate: "MH11AL2524",
        },
        {
          sector_name: "KRD",
          lat: 17.248632,
          lng: 74.177871,
          vehicle_number_plate: "MH11CH2499",
        },
        {
          sector_name: "KOP",
          lat: 16.77121939,
          lng: 74.27648328,
          vehicle_number_plate: "MH46BF8842",
        },
        {
          sector_name: "STR",
          lat: 17.67768505,
          lng: 74.0242399,
          vehicle_number_plate: "MH14GU4077",
        },
        {
          sector_name: "SWL",
          lat: 18.16482411,
          lng: 73.95068184,
          vehicle_number_plate: "MH05DK4695",
        },
        {
          sector_name: "BAR",
          lat: 18.18475027,
          lng: 74.60543403,
          vehicle_number_plate: "MH11CH2775",
        },
        {
          sector_name: "PHR",
          lat: 18.4447963,
          lng: 73.97279928,
          vehicle_number_plate: "MH11CJ3499",
        },
        {
          sector_name: "JJR",
          lat: 18.2728,
          lng: 74.165491,
          vehicle_number_plate: "MH14LB9624",
        },
        {
          sector_name: "PNQP",
          lat: 18.54143142,
          lng: 73.66814405,
          vehicle_number_plate: "MH14CP5566",
        },
        {
          sector_name: "PNQI",
          lat: 18.66328,
          lng: 73.790352,
          vehicle_number_plate: "MH14GU4078",
        },
        {
          sector_name: "SPR",
          lat: 17.730193,
          lng: 75.837023,
          vehicle_number_plate: "MH14GD9426",
        },
        {
          sector_name: "KKB",
          lat: 18.39575617,
          lng: 74.53104089,
          vehicle_number_plate: "MH14HG9264",
        },
        {
          sector_name: "PNQW",
          lat: 18.58529858,
          lng: 73.83276009,
          vehicle_number_plate: "MH14HU9642",
        },
        {
          sector_name: "PNQN",
          lat: 18.74036563,
          lng: 73.74435283,
          vehicle_number_plate: "MH14GD9246",
        },
        {
          sector_name: "JAIO",
          lat: 26.87003759,
          lng: 75.6908454,
          vehicle_number_plate: "MH14BJ1910",
        },
        {
          sector_name: "IDRO",
          lat: 22.86541991,
          lng: 75.96160904,
          vehicle_number_plate: "MH14EM5051",
        },
        {
          sector_name: "LKOD",
          lat: 26.67192972,
          lng: 80.85699734,
          vehicle_number_plate: "MH12SX9264",
        },
        {
          sector_name: "NDAO",
          lat: 28.55796372,
          lng: 77.46829135,
          vehicle_number_plate: "MH12KP6269",
        },
        {
          sector_name: "SMB",
          lat: 21.50184855,
          lng: 83.94405182,
          vehicle_number_plate: "MH14KQ5743",
        },
      ],
      waypoints: [
        { lat: 16.77121939, lng: 78.90309435 },
        { lat: 21.13866742, lng: 78.90309435 },
        { lat: 18.58529858, lng: 73.83276009 },
        // Add more waypoints as needed
      ],
      routes: [],
      route: null,
      marker: null,
    };
  },
  mounted() {
    this.initializeTooltips();
    // this.initMap();
  },
  created() {
    this.getMasterList();
    this.getTrackingSummery();
    this.getLocations();
  },
  methods: {
    getLocations() {
      this.makeRequest("GET", "/vehicles/locations")
        .then((result) => {
          this.locations = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getRandomPositionOnRoute(polylineCoordinates) {
      let randomIndex = Math.floor(
        Math.random() * (polylineCoordinates.length - 1)
      );
      var lat1 = polylineCoordinates[randomIndex].lat;
      var lng1 = polylineCoordinates[randomIndex].lng;
      var lat2 = polylineCoordinates[randomIndex + 1].lat;
      var lng2 = polylineCoordinates[randomIndex + 1].lng;

      var randomLat = lat1 + Math.random() * (lat2 - lat1);
      var randomLng = lng1 + Math.random() * (lng2 - lng1);

      return { lat: randomLat, lng: randomLng };
    },
    getRoutes() {
      this.searchNameMasterList(
        "route_details",
        "route_path",
        null,
        "route_path"
      )
        .then((result) => {
          this.routes = result.data;
          console.log(this.routes);
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    async initMap(id, route, vehicleno = "MH40BG4360") {
      let destination = route.split("-");

      this.waypoints = destination.slice(1, -1);

      console.log(id)

      const mapContainerId = `mapContainer_${id}`;
      const mapContainer = document.getElementById(mapContainerId);
      this.map = new google.maps.Map(mapContainer, {
        zoom: 13,
        zoom: 7,
        center: { lat: this.waypoints[0].lat, lng: this.waypoints[0].lng },
        disableDefaultUI: true,
        mapId: "8e0a97af9386fef",
      });

      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer = new google.maps.DirectionsRenderer();

      this.directionsRenderer.setPanel(document.getElementById("sidebar"));
      const control = document.getElementById("floating-panel");

      this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(control);

      this.directionsRenderer.setMap(this.map);

      this.handleRouteChange(route, vehicleno);
    },
    calculateAndDisplayRoute(vehicleno) {
      const waypoints = this.waypoints.map((waypoint) => ({
        location: new google.maps.LatLng(waypoint.lat, waypoint.lng),
      }));

      const request = {
        origin: waypoints[0].location,
        destination: waypoints[waypoints.length - 1].location,
        waypoints: waypoints.slice(1, -1),
        travelMode: "DRIVING",
      };

      this.directionsService.route(request, (response, status) => {
        if (status === "OK") {
          this.directionsRenderer.setDirections(response);
          let position = this.getRandomPositionOnRoute(this.waypoints);
          this.addMarkenOnRoute(position);
        } else {
          this.sweetAlertSnackbar(
            "Directions request failed due to " + status,
            "error"
          );
        }
      });
    },
    handleRouteChange(route, vehicleno) {
      let destinations = route.split("-");
      let waypoints = this.locations.filter((loc) =>
        destinations.includes(loc.sector_name)
      );
      waypoints.sort((a, b) => {
        let indexA = destinations.indexOf(a.sector_name);
        let indexB = destinations.indexOf(b.sector_name);
        if (indexA > indexB) return 1;
        if (indexA < indexB) return -1;
        return 0;
      });
      this.waypoints = waypoints;
      // let position = this.getRandomPositionOnRoute(this.waypoints);
      // this.addMarkenOnRoute(position, vehicleno);
      this.calculateAndDisplayRoute(vehicleno);
    },
    async addMarkenOnRoute(position, vehicleno) {
      if (this.marker) {
        this.marker.setMap(null);
      }
      const { Map, InfoWindow } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement, PinElement } =
        await google.maps.importLibrary("marker");
      const customIcon = {
        url: "https://cdn-icons-png.flaticon.com/512/2344/2344094.png", // Provide the path to your custom icon image
        scaledSize: new google.maps.Size(25, 25), // Adjust the size as needed
      };
      const pinGlyph = new google.maps.marker.PinElement({
        glyph: vehicleno,
        glyphColor: "white",
      });
      this.marker = new google.maps.Marker({
        position,
        icon: customIcon,
        map: this.map,
      });
    },
    async expandRow(id, route) {
      const isOpen = this.opened === id;
      if (isOpen) {
        this.opened = null;
      } else {
        this.opened = id;
        await this.$nextTick(); // Wait for DOM update
        await this.initMap(id, route);
      }
    },
    initializeTooltips() {
      // Find all elements with class 'popOver' and initialize tooltips for them
      const popOverElements = document.querySelectorAll(".popOver");
      popOverElements.forEach((element) => {
        element.setAttribute("data-toggle", "tooltip");
        element.setAttribute("data-placement", "top");
        element.setAttribute(
          "title",
          element.getAttribute("data-tooltip-text")
        );
        $(element).tooltip({ trigger: "hover" });
      });
    },
    callBot(data) {
      this.isLoading = true;
      let url = "/auto-bot/call";
      let method = "POST";
      let payload = this.createObject(data);
      console.log(payload, "+++")

      this.makeRequest(method, url, payload)
        .then((result) => {
          this.isLoading = false;
          if (result.data.flag == 1) {
            this.sweetAlertSnackbar("Call scheduled successfully","success");
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    createObject(trackingDetails) {
      const { calltype, ...data } = trackingDetails;
      let initialState = {
        mobilenum: trackingDetails.driver_mobile,
        vehicleno: trackingDetails.vehicle_registration_no,
        Vehicledetails: trackingDetails.vehicle_type,
        TripId: trackingDetails.trip_id,
        DriverName: trackingDetails.driver_name,
        DriverMobile: trackingDetails.driver_mobile,
        language: trackingDetails.driver_language,
        guid: String(Math.floor(Math.random() * 1000000000) + 1),
      };
      let finalObject = {};

      let routePath = data.route_path;
      let destinations = routePath.split("-");

      let firstPoint = destinations[0];
      let intermediatePoints = destinations.slice(1, -1);
      let finalPoint = destinations[destinations.length - 1];

      switch (calltype) {
        case 1:
          finalObject = {
            calltype,
            ...initialState,
            departureTime: "10:15 AM",
            arrivalTime: "12:10 AM",
          };
          break;
        case 2:
        case 3:
          finalObject = {
            calltype,
            ...initialState,
            startPoint: `Warehouse ${firstPoint}`,
            intermediatePoints: `Distribution center ${intermediatePoints.join(
              ","
            )}`,
            finalPoint,
          };
          break;
        case 4:
          finalObject = {
            calltype,
            ...initialState,
            ETA: "10:10 AM",
            currentDelay: "Additional 45 minutes",
          };
          break;
        case 5:
          finalObject = {
            calltype,
            ...initialState,
            currentLocation: "Distribution Center NAGO",
            idleWaitTime: "40 minutes",
          };
          break;
        case 6:
          finalObject = {
            calltype,
            ...initialState,
            entryGate: "PNQO Entry Gate 1",
            currentWaitTime: "45 minutes",
          };
          break;
        case 7:
          finalObject = {
            calltype,
            ...initialState,
            loadingDockNo: "Dock No. 4",
            currentWaitTime: "30 minutes",
          };
          break;
        case 8:
          finalObject = {
            calltype,
            ...initialState,
            breakDownLocation: "Highway Exit 5",
            estimatedRepairTime: "2 hour 30 minutes",
          };
          break;
        case 9:
          finalObject = {
            calltype,
            ...initialState,
            loadUnloadDockNo: "Dock No. 18",
            currentWaitTime: "1 hour 20 minutes",
          };
          break;
        case 10:
          finalObject = {
            calltype,
            ...initialState,
          };
          break;
        default:
          finalObject = {};
      }
      return finalObject;
    },
    getTrackingSummery() {
      this.isSummaryLoading = true;
      let url = "/vehicles/ct/tracking/summary";
      let method = "POST";
      this.makeRequest(method, url)
        .then((result) => {
          this.isSummaryLoading = false;
          this.summary = result.data.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    toggleMasterCreate() {
      if (this.isFormEdit) {
        this.resetform("haul_details");
      }
      this.isFormEdit = false;
      this.haul_details = !this.haul_details;
    },
    resetPageData() {
      this.haul_form.list = [];
      this.haul_form.totalcount = 0;
      this.haul_form.pageCount = 1;
    },
    getMasterList(tab = "haul_form", type) {
      this.isMasterListLoading = true;
      this.resetPageData();
      let url = this[tab].url;
      let method = "POST";
      let payload = {
        page: this[tab].page,
        rows: this[tab].pagelimit,
        type,
      };
      this.makeRequest(method, url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this[tab].list = result.data.data.rows;
          this[tab].totalcount = result.data.data.count;
          this[tab].pageCount = Math.ceil(
            result.data.data.count / this[tab].pagelimit
          );
        })
        .catch((e) => {
          this.isMasterListLoading = false;
          this.displayError(e);
        });
    },
    resetform() {},
    handlePageChange(pageNum, tab) {
      this[tab].pageoffset = pageNum;
      this[tab].currPageNum = pageNum - 1;

      this.getMasterList(tab);
      setTimeout(() => {
        $("html, body").animate({
          scrollTop: $(`#${tab}`).offset().top - 70,
        });
      }, 500);
    },
  },
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}
#overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}

.overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}

.cell_active:hover {
  background-color: #dee2e6;
  cursor: pointer;
}
.map-container {
  height: 400px;
  width: 100%;
}
.cls-pointer {
  cursor: pointer;
  background-color: #c3fae8;
}

#container {
  height: 100%;
  display: flex;
}
#sidebar {
  flex-basis: 15rem;
  flex-grow: 1;
  padding: 1rem;
  max-width: 30rem;
  height: 400px;
  box-sizing: border-box;
  overflow: auto;
}

#floating-panel {
  position: absolute;
  top: 10px;
  left: 25%;
  z-index: 5;
  background-color: #fff;
  padding: 5px;
  border: 1px solid #999;
  text-align: center;
  font-family: "Roboto", "sans-serif";
  line-height: 30px;
  padding-left: 10px;
}

#floating-panel {
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3);
  margin: 10px;
  padding: 0 0.5em;
  font: 400 18px Roboto, Arial, sans-serif;
  overflow: hidden;
  padding: 5px;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  height: auto;
}
.map-container {
  flex: auto;
}
#sidebar {
  flex: 0 1 auto;
  padding: 0;
}
#sidebar > div {
  padding: 0.5rem;
}
</style>
